import { envConfig } from '@/configs';
import { http } from './http';
import packageJson from '../../package.json';

export const fetchList = () => {
  const url = envConfig.servicesURL ?? 'https://api-v2.samad.app/config/universities.json';
  const fullurl = `${url}?version=${packageJson.version}`;
  return http.get<UniversityEntityOriginal[]>(fullurl, {
    headers: {
      'Cache-Control': 'max-age=1800' // 30 minutes
    }
  });
};
